import { TraceabilityState } from "@/vuex/modules/traceability/traceability.types";

export const state: TraceabilityState = {
  metrcConfig: false
};
